module.exports = __webpack_public_path__ + "static/media/view_goal.847ea78d.png";